<template>
  <div>
    <header>
      <Header />
    </header>
    <div>
      <div v-if="isDemo()" class="commingSoon">
        <div class="commingSoonMessage">
          Coming Soon
        </div>
      </div>
      <div v-else id="main">
        <section class="photographersList">
          <div class="photographersListTitle">
            <div class="inner4">
              <h1>展示者一覧</h1>
              <p class="titleSub">Online Exhibition</p>
            </div><!-- /inner2-->
          </div><!-- /photographersListTitle-->
          <div class="searchArea">
            <input type="text" placeholder="検索..." class="searchTextbox" v-model="query" @input="onInput" />
          </div>
          <div class="photographersListBody">
            <div class="inner2">
              <template v-if="searchedAwardTypes && searchedAwardTypes.length > 0">
              <div v-for="awardType in searchedAwardTypes" class="listBlock" :key="awardType">
                <h2>{{awardTypeNames[awardType]}}</h2>
                <ul v-if="searchedWinnersByAwardType && searchedWinnersByAwardType[awardType]">
                  <li v-for="winner in searchedWinnersByAwardType[awardType]" :key="winner.id">
                    <router-link :to="getWinnerLink(winner)">
                      {{winner.name}}
                    </router-link>
                  </li>
                </ul>
              </div><!-- /listBlock-->
              </template>
              <div class="searchErrorMessage" v-else>
                指定された検索条件の出展者はいませんでした。
              </div>
            </div><!-- /inner-->
          </div><!-- /photographersListBody-->
          <div class="mapArea">
            <div class="mapTitle">
              展示会場配置図
            </div>
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              viewBox="0 0 960 448.4" style="enable-background:new 0 0 960 448.4;" xml:space="preserve">
                <g id="mapbase">
                    <rect x="41.6" y="0.28" class="st0" width="5.11" height="361.67"/>
                    <rect x="41.6" y="404.94" class="st0" width="5.11" height="43.32"/>
                    <rect x="954.52" y="17.89" class="st0" width="5.11" height="83.49"/>
                    <rect x="895.35" y="37.09" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 996.7245 -799.0895)" class="st0" width="5.11" height="123.45"/>
                    <rect x="935.33" y="-2.3" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 957.3354 -918.4401)" class="st0" width="5.11" height="43.49"/>
                    <polygon class="st0" points="212.04,408.02 251.11,408.02 192.35,448.27 153.28,448.27 	"/>
                    <rect x="98.98" y="385.77" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 547.2503 344.1728)" class="st0" width="5.11" height="119.88"/>
                    <rect x="41.6" y="0.28" class="st0" width="820.25" height="22.63"/>
                    <rect x="212.04" y="408.02" class="st0" width="624.14" height="22.63"/>
                    <rect x="211.61" y="100.38" class="st0" width="23.14" height="327.19"/>
                    <rect x="812.6" y="59.94" class="st0" width="23.14" height="353.35"/>
                    <path class="st0" d="M44.16,141.03H61c6.07,0,11,4.92,11,11c0,6.07-4.92,11-11,11H45.06"/>
                    <path class="st0" d="M44.16,412.16H61c6.07,0,11,4.92,11,11c0,6.07-4.92,11-11,11H45.06"/>
                    <circle class="st0" cx="61" cy="315" r="11"/>
                    <rect x="0.14" y="277.78" class="st0" width="30.79" height="121"/>
                    <rect x="186.15" y="341.52" class="st1" width="18.57" height="62.39"/>
                    <rect x="242.96" y="26.28" class="st1" width="55.58" height="16.12"/>
                    <rect x="239.83" y="103.01" class="st1" width="114.74" height="223.9"/>
                    <rect x="925.69" y="24.29" class="st1" width="25.09" height="69.09"/>
                    <rect x="845.86" y="71.12" class="st1" width="103.46" height="22.26"/>
                    <rect x="853.89" y="40.28" width="65.6" height="17.2"/>
                    <g>
                        <g>
                            <path class="st2" d="M862.69,51.04c-0.11,0.35-0.35,0.94-0.8,1.44l-0.57-0.5c0.31-0.35,0.6-0.84,0.68-1.25L862.69,51.04z
                    M861.66,45.35h2.6v5.24h-2.6V45.35z M862.42,46.08v0.76h1.08v-0.76H862.42z M862.42,47.54v0.78h1.08v-0.78H862.42z
                    M862.42,49.02v0.83h1.08v-0.83H862.42z M863.94,52.02c0.03-0.05,0.07-0.09,0.09-0.12l-0.35,0.16c-0.13-0.27-0.18-0.35-0.6-1.07
                    l0.68-0.25c0.17,0.24,0.42,0.64,0.51,0.79c0.58-1.01,0.61-2.53,0.61-3.1v-3.09h3.94v0.77h-3.13v1.1h2.85v0.81
                    c-0.05,0.39-0.23,1.68-0.92,2.69c0.28,0.31,0.63,0.61,1.31,0.99l-0.4,0.76c-0.29-0.17-0.83-0.49-1.41-1.12
                    c-0.6,0.64-1.2,0.92-1.58,1.08l-0.41-0.71c0.31-0.11,0.88-0.32,1.5-1c-0.6-0.94-0.78-1.95-0.85-2.4l0.75-0.18
                    c0.05,0.43,0.13,1.16,0.6,1.92c0.49-0.85,0.59-1.73,0.63-2.09h-2.05c0.02,1.98-0.22,3.27-1.04,4.53L863.94,52.02z"/>
                            <path class="st2" d="M873.16,49.34c-0.13,1.95-0.8,2.59-2.69,3.16l-0.38-0.79c1.48-0.35,2.2-0.72,2.2-2.43L873.16,49.34z
                    M870.18,45.7h3.29v-0.59h0.83v0.59h3.29v0.78h-3.29v0.59h2.85v0.7h-6.52v-0.7h2.84v-0.59h-3.29V45.7z M870.37,48.25h7.01v1.54
                    h-0.84v-0.83h-5.34v0.83h-0.83V48.25z M877.61,50.7c-0.06,0.56-0.1,0.97-0.2,1.18c-0.22,0.43-0.52,0.46-0.66,0.46h-1.64
                    c-0.24,0-0.71-0.07-0.71-0.62V49.3h0.81v2.09c0,0.11,0.01,0.19,0.15,0.19h1.16c0.05,0,0.14-0.06,0.17-0.2
                    c0.04-0.16,0.09-0.75,0.1-0.87L877.61,50.7z"/>
                            <path class="st2" d="M885.16,46.2v5.43h-5.67v-0.85h4.75v-3.73h-4.71V46.2H885.16z"/>
                            <path class="st2" d="M894.37,48.26v0.95h-6.96v-0.95H894.37z"/>
                            <path class="st2" d="M899.25,47.1v-1.65h0.92v1.65h2.84v0.84h-2.87v0.14c0,1.75-0.81,3.34-3.07,4.09l-0.48-0.71
                    c1.81-0.6,2.64-1.67,2.64-3.19v-0.34h-2.97V47.1H899.25z"/>
                            <path class="st2" d="M911.79,48.26v0.95h-6.96v-0.95H911.79z"/>
                        </g>
                    </g>
                    <g>
                        <path d="M867.2,61.75c-0.17-0.11-0.55-0.27-1.05-0.27c-0.83,0-1.15,0.51-1.15,0.94c0,0.59,0.36,0.89,1.16,1.22
                  c0.96,0.41,1.46,0.9,1.46,1.76c0,0.95-0.69,1.68-1.98,1.68c-0.54,0-1.13-0.17-1.43-0.38l0.18-0.54c0.32,0.21,0.8,0.37,1.29,0.37
                  c0.8,0,1.27-0.43,1.27-1.07c0-0.59-0.32-0.95-1.1-1.26c-0.9-0.34-1.51-0.86-1.51-1.69c0-0.91,0.74-1.58,1.83-1.58
                  c0.56,0,1,0.14,1.22,0.28L867.2,61.75z"/>
                        <path d="M872.37,66.99h-0.65v-2.53c0-0.7-0.25-1.3-0.99-1.3c-0.5,0-1.13,0.42-1.13,1.2v2.63h-0.65v-6.27h0.65v2.66h0.02
                  c0.28-0.47,0.8-0.76,1.33-0.76s1.43,0.32,1.43,1.77V66.99z"/>
                        <path d="M877.57,64.82c0,1.59-1.05,2.27-2,2.27c-1.1,0-1.94-0.82-1.94-2.2c0-1.46,0.91-2.27,2-2.27
                  C876.8,62.61,877.57,63.51,877.57,64.82z M875.61,63.12c-0.93,0-1.31,0.91-1.31,1.73c0,0.95,0.53,1.72,1.29,1.72
                  c0.78,0,1.32-0.77,1.32-1.73C876.91,64.08,876.54,63.12,875.61,63.12z"/>
                        <path d="M879.48,63.44c0.3-0.53,0.79-0.82,1.46-0.82c1.01,0,1.74,0.87,1.74,2.18c0,1.57-0.92,2.29-1.86,2.29
                  c-0.56,0-1.04-0.26-1.29-0.68h-0.02v2.34h-0.65v-4.65c0-0.56-0.02-0.99-0.03-1.38h0.59l0.04,0.73H879.48z M879.52,65.29
                  c0,0.83,0.62,1.27,1.2,1.27c0.84,0,1.3-0.72,1.3-1.74c0-0.89-0.45-1.67-1.28-1.67c-0.73,0-1.22,0.71-1.22,1.33V65.29z"/>
                        <path d="M890.06,66.81c-0.27,0.13-0.81,0.27-1.49,0.27c-1.54,0-2.78-1-2.78-3.02c0-1.93,1.2-3.13,2.95-3.13
                  c0.71,0,1.13,0.15,1.32,0.24l-0.17,0.55c-0.27-0.13-0.66-0.24-1.13-0.24c-1.36,0-2.28,0.91-2.28,2.56c0,1.57,0.85,2.49,2.24,2.49
                  c0.46,0,0.9-0.1,1.2-0.24L890.06,66.81z"/>
                        <path d="M894.93,64.82c0,1.59-1.05,2.27-2,2.27c-1.1,0-1.94-0.82-1.94-2.2c0-1.46,0.91-2.27,2-2.27
                  C894.15,62.61,894.93,63.51,894.93,64.82z M892.96,63.12c-0.93,0-1.31,0.91-1.31,1.73c0,0.95,0.53,1.72,1.29,1.72
                  c0.78,0,1.32-0.77,1.32-1.73C894.26,64.08,893.89,63.12,892.96,63.12z"/>
                        <path d="M898.18,63.26c-0.07-0.01-0.14-0.02-0.24-0.02c-0.71,0-1.07,0.7-1.07,1.42v2.32h-0.65v-3c0-0.46-0.01-0.87-0.03-1.28h0.57
                  l0.03,0.82h0.02c0.19-0.53,0.64-0.92,1.16-0.92c0.07,0,0.13,0.02,0.2,0.02V63.26z"/>
                        <path d="M902.67,66.99h-0.65v-2.53c0-0.7-0.25-1.31-1-1.31c-0.56,0-1.12,0.47-1.12,1.22v2.62h-0.65v-3.18
                  c0-0.44-0.02-0.76-0.03-1.11h0.58l0.04,0.7h0.02c0.21-0.42,0.71-0.79,1.37-0.79c0.53,0,1.44,0.32,1.44,1.77V66.99z"/>
                        <path d="M907.27,66.81c-0.24,0.12-0.69,0.27-1.34,0.27c-1.25,0-1.99-0.88-1.99-2.16c0-1.34,0.75-2.31,1.91-2.31
                  c1.32,0,1.65,1.21,1.65,1.95c0,0.15-0.01,0.26-0.02,0.36h-2.91c0.01,1.18,0.68,1.63,1.45,1.63c0.53,0,0.85-0.11,1.12-0.22
                  L907.27,66.81z M906.86,64.44c0.01-0.58-0.24-1.33-1.07-1.33c-0.78,0-1.13,0.75-1.19,1.33H906.86z"/>
                        <path d="M910.74,63.26c-0.07-0.01-0.14-0.02-0.24-0.02c-0.71,0-1.07,0.7-1.07,1.42v2.32h-0.65v-3c0-0.46-0.01-0.87-0.03-1.28h0.57
                  l0.03,0.82h0.02c0.19-0.53,0.64-0.92,1.16-0.92c0.07,0,0.13,0.02,0.2,0.02V63.26z"/>
                    </g>
                    <rect x="42.07" y="371.82" width="33.77" height="17.2"/>
                    <g>
                        <g>
                            <path class="st2" d="M50.22,376.91h3.02c-0.07,2.7,0.54,4.71,3.36,6.24l-0.58,0.82c-1.06-0.62-2.56-1.75-3.24-4.08
                    c-0.53,1.7-1.18,2.71-3.25,4.08l-0.56-0.78c1.92-1.03,3.36-2.81,3.39-5.44h-2.14V376.91z"/>
                            <path class="st2" d="M67.13,383.33h-4.7v0.49h-0.86v-6.62H68v6.62h-0.86V383.33z M67.13,378.04h-4.7v4.46h4.7V378.04z"/>
                        </g>
                    </g>
                    <g>
                        <path class="st2" d="M15.2,293.16c-0.41,0.02-2.41,0.09-2.85,0.09l-0.08-0.8c2.12,0.02,4.23-0.04,6.31-0.46l0.23,0.79
                  c-0.49,0.08-1.33,0.22-2.78,0.34v1.09h2.87v0.78h-2.87v1.08h3.25v0.78h-3.25v1.8c0,0.7-0.54,0.71-0.6,0.71h-1.77l-0.16-0.81h1.47
                  c0.1,0,0.24,0,0.24-0.18v-1.53h-3.24v-0.78h3.24v-1.08h-2.85v-0.78h2.85V293.16z"/>
                        <path class="st2" d="M11.89,305.95c0.27-0.06,0.42-0.09,1.15-0.3v-1.77h-1.1v-0.73h1.1v-1.41h0.79v1.41h0.82v0.73h-0.82v1.52
                  c0.48-0.16,0.62-0.23,0.86-0.33l0.05,0.78c-0.24,0.11-0.49,0.24-0.92,0.4v2.04c0,0.82-0.59,0.82-0.78,0.82H12.1L12,308.29h0.8
                  c0.16,0,0.24-0.01,0.24-0.18v-1.58c-0.5,0.16-0.77,0.21-1.04,0.26L11.89,305.95z M14.92,301.74h0.81v0.89
                  c0.41-0.05,1.62-0.17,2.88-0.79l0.39,0.69c-0.7,0.36-1.98,0.7-3.27,0.82v0.33c0,0.25,0.16,0.27,0.36,0.27h2.05
                  c0.27,0,0.35,0,0.42-0.98l0.82,0.24c-0.14,1.43-0.39,1.52-1.03,1.52h-2.5c-0.75,0-0.93-0.27-0.93-0.78V301.74z M19.02,305.33v3.78
                  h-0.79v-0.25h-2.41v0.25h-0.78v-3.78H19.02z M15.82,306.01v0.75h2.41v-0.75H15.82z M15.82,307.4v0.76h2.41v-0.76H15.82z"/>
                        <path class="st2" d="M12.29,313.61c0.66,0.27,1.01,0.5,1.34,0.75l-0.47,0.75c-0.18-0.14-0.64-0.48-1.25-0.75L12.29,313.61z
                  M13.99,316c-0.33,0.78-0.89,1.87-1.6,2.75l-0.48-0.84c0.44-0.54,1-1.39,1.4-2.38L13.99,316z M12.66,311.45
                  c0.31,0.14,0.78,0.38,1.35,0.77l-0.51,0.72c-0.34-0.28-0.6-0.45-1.29-0.82L12.66,311.45z M15.02,311.48
                  c0.21,0.3,0.54,0.85,0.82,1.58l-0.78,0.25c-0.13-0.36-0.45-1.08-0.75-1.52L15.02,311.48z M16.33,313.45v-2.01h0.81v2.01h1.87v4.74
                  c0,0.45-0.26,0.63-0.67,0.63h-1.31l-0.12-0.8h1.14c0.18,0,0.2-0.07,0.2-0.2v-0.81h-3v1.8h-0.8v-5.36H16.33z M15.25,314.2v0.66h3
                  v-0.66H15.25z M15.25,315.59v0.71h3v-0.71H15.25z M19.28,311.77c-0.23,0.58-0.52,1.11-0.93,1.6l-0.7-0.31
                  c0.5-0.61,0.75-1.24,0.87-1.54L19.28,311.77z"/>
                        <path class="st2" d="M12.12,321.6h3.08v-0.44H16v0.44h3.12v0.63H16v0.38h2.75v0.54H16v0.37h3.32v0.63h-7.37v-0.63h3.26v-0.37
                  h-2.71v-0.54h2.71v-0.38h-3.08V321.6z M12.73,325.69c0.09-0.48,0.13-0.85,0.17-1.2h5.71c0,0.3,0,0.67-0.03,1.2h0.74v0.67h-0.78
                  c-0.01,0.13-0.02,0.26-0.05,0.53h0.64v0.66h-0.74c-0.06,0.34-0.18,0.97-1,0.97h-1.11l-0.17-0.68h1.13c0.26,0,0.29-0.12,0.33-0.29
                  h-4.45c-0.06,0.22-0.1,0.35-0.19,0.59l-0.78-0.19c0.1-0.29,0.23-0.63,0.44-1.58h-0.65v-0.67H12.73z M14.98,326.89
                  c0.03-0.16,0.06-0.36,0.09-0.53h-1.69c-0.04,0.2-0.05,0.25-0.12,0.53H14.98z M15.17,325.69c0.02-0.22,0.03-0.35,0.05-0.54H13.6
                  c-0.02,0.2-0.04,0.3-0.08,0.54H15.17z M17.67,326.89c0.02-0.09,0.03-0.31,0.05-0.53h-1.9c-0.04,0.28-0.06,0.41-0.08,0.53H17.67z
                  M17.78,325.69c0.01-0.08,0.03-0.43,0.04-0.54h-1.87c-0.02,0.17-0.02,0.23-0.04,0.54H17.78z"/>
                        <path class="st2" d="M16.62,333.03c0-0.6,0-1.07-1.17-1.07c-0.82,0-1.15,0.2-1.15,0.7c0,0.26,0.13,0.44,0.38,0.68l2.46,2.42
                  c0.09-0.21,0.09-0.41,0.09-0.76v-0.49h0.89v0.57c0,0.26,0,0.83-0.32,1.3l1.01,0.98h-1.25L17.17,337c-0.2,0.16-0.56,0.44-1.91,0.44
                  c-1.42,0-2.46-0.35-2.46-1.84c0-0.83,0.24-1.47,1.18-1.79c-0.21-0.17-0.59-0.45-0.59-1.18c0-1.17,0.72-1.5,2.06-1.5
                  c1.89,0,2.08,0.87,2.06,1.91H16.62z M14.57,334.41c-0.19,0.02-0.86,0.17-0.86,1.14c0,0.61,0.21,1.04,1.65,1.04
                  c0.2,0,0.84,0,1.18-0.27L14.57,334.41z"/>
                        <path class="st2" d="M15.67,341.96c-0.42,0.35-0.63,0.46-0.88,0.58l-0.38-0.72v0.42h-0.67v0.41c0.14,0.31,0.49,0.85,1,1.36
                  l-0.4,0.76c-0.38-0.58-0.43-0.65-0.6-1.03v3.66H13v-3.54c-0.2,0.78-0.42,1.24-0.89,1.96l-0.33-1.04c0.42-0.56,0.82-1.2,1.13-2.56
                  h-1v-0.78H13v-1.44h0.75v1.44h0.67v0.35c0.99-0.52,1.51-1.05,2.02-1.79h1.02c0.68,0.93,1.08,1.26,2.05,1.76l-0.43,0.71
                  c-0.21-0.13-0.45-0.26-0.8-0.54v0.36h-0.94v0.63h1.74v2.3h-1.54c0.24,0.49,0.56,0.96,1.9,1.41l-0.36,0.75
                  c-0.42-0.15-1.52-0.53-2.11-1.75c-0.56,1.15-1.4,1.55-2.14,1.78l-0.41-0.72c0.44-0.11,1.5-0.38,1.92-1.47H14.8v-2.3h1.76v-0.63
                  h-0.88V341.96z M16.5,344.56c0.05-0.29,0.06-0.42,0.06-0.93h-1v0.93H16.5z M17.89,341.64c-0.52-0.48-0.78-0.81-0.94-1.03
                  c-0.22,0.27-0.49,0.61-0.91,1.03H17.89z M18.31,344.56v-0.93h-0.99c0,0.49,0,0.6-0.04,0.93H18.31z"/>
                        <path class="st2" d="M12.23,351.89c0.69,0.27,1.14,0.58,1.37,0.74l-0.5,0.75c-0.28-0.22-0.72-0.53-1.26-0.75L12.23,351.89z
                  M13.85,354.36c-0.77,1.74-0.99,2.12-1.44,2.71l-0.53-0.81c0.44-0.54,0.74-1.03,1.29-2.43L13.85,354.36z M12.65,349.76
                  c0.31,0.13,1.03,0.52,1.35,0.77l-0.49,0.71c-0.47-0.38-1.02-0.67-1.29-0.82L12.65,349.76z M14.11,353.67h4.9v2.42h0.31v0.75H13.6
                  v-0.75h0.5V353.67z M18.82,353.09h-4.51v-3.11h4.51V353.09z M14.84,354.38v1.71h0.68v-1.71H14.84z M15.09,350.67v0.53h2.95v-0.53
                  H15.09z M18.03,351.8h-2.95v0.61h2.95V351.8z M16.2,354.38v1.71h0.68v-1.71H16.2z M17.56,354.38v1.71h0.69v-1.71H17.56z"/>
                        <path class="st2" d="M18.48,359.88v0.86h-2.4v3.8h2.82v0.86h-6.61v-0.86h2.85v-3.8h-2.43v-0.86H18.48z"/>
                        <path class="st2" d="M14.11,372.83H13.2v-4.26h0.91V372.83z M18.07,371.41c0,3.14-1.87,3.5-4.16,3.74l-0.29-0.86
                  c1.14-0.07,1.89-0.2,2.57-0.55c0.91-0.46,0.96-1.62,0.96-1.91v-3.4h0.93V371.41z"/>
                        <path class="st2" d="M19.01,377.94c-0.34,2.12-1.53,2.93-2.35,3.36l-0.59-0.71c0.53-0.24,1.31-0.65,1.73-1.83h-5.52v-0.83H19.01z
                  M12.57,383.67c1.4-0.54,2.35-1.4,2.36-4.17l0.96,0.02c-0.09,2.82-1.08,4.03-2.75,4.84L12.57,383.67z"/>
                    </g>
                    <g>
                        <rect x="9.47" y="405.33" class="st0" width="21.45" height="42.94"/>
                        <g>
                            <path class="st2" d="M18.73,420.8c0.16,0.21,0.6,0.75,1.4,1.19c0.79-0.48,1.25-1.07,1.44-1.31h-3.91v-0.75h4.89v0.75
                    c-0.17,0.29-0.6,1.07-1.54,1.71c1.22,0.41,2.29,0.49,2.84,0.53l-0.31,0.85c-1.63-0.17-2.74-0.57-3.4-0.89
                    c-1.18,0.52-2.31,0.72-3.36,0.85l-0.35-0.81c1.67-0.16,2.49-0.41,2.86-0.54c-0.75-0.55-1.06-0.99-1.29-1.35L18.73,420.8z
                    M17.73,418.6c-0.1-0.24-0.32-0.69-0.45-0.93l0.38-0.14c-0.34-0.01-0.64-0.01-0.85-0.02l-0.16-0.71
                    c0.42,0.02,0.82,0.03,1.43,0.03c2.53,0,4.18-0.29,5.07-0.47l0.43,0.68c-0.35,0.07-0.7,0.14-1.2,0.21l0.64,0.2
                    c-0.27,0.61-0.32,0.72-0.56,1.15h1.16v2.01H22.8v-1.26h-5.39v1.26h-0.82v-2.01H17.73z M19.81,418.6c-0.2-0.64-0.26-0.79-0.4-1.09
                    c-0.27,0.01-0.75,0.02-1.31,0.02c0.16,0.35,0.31,0.71,0.46,1.07H19.81z M21.57,418.6c0.3-0.53,0.51-1.14,0.56-1.31
                    c-0.48,0.06-0.61,0.08-1.84,0.17c0.16,0.44,0.25,0.72,0.34,1.14H21.57z"/>
                            <path class="st2" d="M17.34,432.84c-0.31,0.46-0.47,0.63-0.66,0.82l-0.36-0.92c0.8-0.9,1.36-2.15,1.58-3.22l0.84,0.13
                    c-0.08,0.31-0.23,0.87-0.6,1.71v5.54h-0.8V432.84z M22.09,429.54h0.84v1.66h0.89v0.81h-0.89v4.06c0,0.56-0.26,0.83-0.93,0.83
                    h-1.45l-0.11-0.83l1.45,0.02c0.19,0,0.2-0.13,0.2-0.23v-3.85h-3.52v-0.81h3.52V429.54z M19.55,432.56
                    c0.69,0.8,1.13,1.52,1.35,1.88l-0.72,0.49c-0.17-0.31-0.64-1.11-1.32-1.91L19.55,432.56z"/>
                        </g>
                    </g>
                    <rect x="871.95" y="0.28" width="33.77" height="17.2"/>
                    <g>
                        <g>
                            <path class="st2" d="M879.83,5.68h0.84v2.13h1.79v-2.7h0.84v2.7h1.82V5.68h0.84V8.6h-2.66v2.68h2.09v-2.2h0.84v3.39h-0.84v-0.41
                    h-5v0.41h-0.83V9.09h0.83v2.2h2.07V8.6h-2.63V5.68z"/>
                            <path class="st2" d="M897.26,11.79h-4.7v0.49h-0.86V5.66h6.42v6.62h-0.86V11.79z M897.26,6.5h-4.7v4.45h4.7V6.5z"/>
                        </g>
                    </g>
                    <g>
                        <path d="M886.08,26.99h-3.15v-5.98h3.02v0.55h-2.37v2.02h2.23v0.54h-2.23v2.31h2.5V26.99z"/>
                        <path d="M890.09,22.71l-1.41,2.07l1.45,2.2h-0.75l-0.64-1c-0.16-0.26-0.3-0.49-0.46-0.77h-0.02c-0.13,0.27-0.29,0.5-0.46,0.77
                  l-0.63,1h-0.72l1.47-2.18l-1.4-2.09h0.73l0.62,0.95c0.16,0.24,0.29,0.46,0.43,0.71h0.02c0.13-0.25,0.28-0.49,0.43-0.71l0.6-0.95
                  H890.09z"/>
                        <path d="M891.2,21.96c-0.25,0-0.42-0.2-0.42-0.45c0-0.24,0.18-0.44,0.43-0.44c0.26,0,0.42,0.2,0.42,0.44
                  C891.63,21.79,891.45,21.96,891.2,21.96z M891.53,26.99h-0.65v-4.27h0.65V26.99z"/>
                        <path d="M893,21.94l0.64-0.22v1h1.11v0.51h-1.11v2.47c0,0.54,0.16,0.84,0.58,0.84c0.2,0,0.33-0.02,0.44-0.06l0.04,0.5
                  c-0.14,0.06-0.36,0.1-0.64,0.1c-1.04,0-1.07-0.94-1.07-1.4v-2.46h-0.66v-0.51H893V21.94z"/>
                    </g>
                    <rect x="257.24" y="207.85" width="76.05" height="17.2"/>
                    <g>
                        <g>
                            <path class="st2" d="M265.55,212.73v2.01c1.91,0.54,3.4,1.4,3.92,1.7l-0.42,0.9c-0.88-0.53-2.42-1.4-3.5-1.67v3.98h-0.94v-6.93
                    H265.55z"/>
                            <path class="st2" d="M278.82,215.62v0.95h-6.96v-0.95H278.82z"/>
                            <path class="st2" d="M287.72,213.8c-0.23,1.32-0.87,5.15-5.61,5.76l-0.37-0.8c2.56-0.38,4.06-1.35,4.81-4.13h-2.8
                    c-0.71,0.89-1.3,1.47-1.89,1.8l-0.58-0.67c0.47-0.27,1.82-1.07,2.55-3.08l0.96,0.19c-0.09,0.25-0.17,0.47-0.45,0.93H287.72z"/>
                            <path class="st2" d="M290.23,218.72c1.68-0.61,3.65-2.32,4.53-4.71h-4.08v-0.85h5.27c-0.11,0.47-0.38,1.71-1.51,3.25
                    c0.92,0.74,1.81,1.51,2.65,2.33l-0.74,0.75c-0.89-1.04-2.09-2.1-2.45-2.4c-0.91,1.05-1.9,1.87-3.14,2.37L290.23,218.72z"/>
                            <path class="st2" d="M306.05,215.1v0.82h-2.6c-0.12,1.88-0.71,3.18-3.24,3.67l-0.41-0.75c2.35-0.38,2.67-1.45,2.75-2.93h-3.06
                    v-0.82H306.05z M305.41,213.09v0.82h-5.27v-0.82H305.41z"/>
                            <path class="st2" d="M315.61,215.62v0.95h-6.96v-0.95H315.61z"/>
                            <path class="st2" d="M320.3,216.52c-0.92-0.5-1.87-0.81-2.2-0.91l0.35-0.82c0.12,0.03,1.41,0.4,2.21,0.84L320.3,216.52z
                    M318.55,218.46c2.96-0.24,4.31-1.18,5.32-4.27l0.85,0.38c-1.05,2.94-2.39,4.44-5.94,4.83L318.55,218.46z M320.91,214.7
                    c-0.83-0.42-1.58-0.67-2.19-0.85l0.38-0.82c1.18,0.35,1.77,0.62,2.21,0.82L320.91,214.7z M323.29,213.93
                    c-0.11-0.53-0.21-0.85-0.37-1.26l0.64-0.14c0.2,0.47,0.27,0.67,0.4,1.25L323.29,213.93z M324.44,213.76
                    c-0.18-0.71-0.33-1.03-0.41-1.2l0.64-0.14c0.22,0.45,0.37,0.97,0.42,1.16L324.44,213.76z"/>
                        </g>
                    </g>
                    <g>
                        <path class="st3" d="M281.1,228.1h-1.76v5.42h-0.65v-5.42h-1.76v-0.55h4.17V228.1z"/>
                        <path class="st3" d="M284.37,232.5c0,0.35,0.01,0.72,0.06,1.02h-0.6l-0.06-0.55h-0.02c-0.22,0.34-0.66,0.64-1.26,0.64
                  c-0.82,0-1.25-0.6-1.25-1.22c0-1.03,0.89-1.58,2.48-1.58c0-0.36,0-1.18-0.97-1.18c-0.37,0-0.75,0.1-1.04,0.31l-0.16-0.45
                  c0.35-0.23,0.82-0.36,1.3-0.36c1.21,0,1.52,0.85,1.52,1.7V232.5z M283.73,231.3c-0.81,0-1.82,0.12-1.82,1.02
                  c0,0.55,0.35,0.79,0.74,0.79c0.64,0,1.08-0.49,1.08-1V231.3z"/>
                        <path class="st3" d="M286.27,233.52h-0.65v-6.27h0.65V233.52z"/>
                        <path class="st3" d="M290.88,233.52h-0.8l-1.47-2.11l-0.39,0.45v1.66h-0.65v-6.27h0.65v3.99h0.02c0.1-0.15,0.25-0.34,0.37-0.48
                  l1.28-1.51h0.78l-1.61,1.76L290.88,233.52z"/>
                        <path class="st3" d="M295.98,228.29c-0.17-0.11-0.55-0.27-1.05-0.27c-0.83,0-1.15,0.51-1.15,0.94c0,0.59,0.36,0.89,1.16,1.22
                  c0.96,0.41,1.46,0.9,1.46,1.76c0,0.95-0.69,1.68-1.98,1.68c-0.54,0-1.13-0.17-1.43-0.38l0.18-0.54c0.32,0.21,0.8,0.37,1.29,0.37
                  c0.8,0,1.27-0.43,1.27-1.07c0-0.59-0.32-0.95-1.1-1.26c-0.9-0.34-1.51-0.86-1.51-1.69c0-0.91,0.74-1.58,1.83-1.58
                  c0.56,0,1,0.14,1.22,0.28L295.98,228.29z"/>
                        <path class="st3" d="M297.59,228.47l0.64-0.22v1h1.11v0.51h-1.11v2.47c0,0.54,0.16,0.84,0.58,0.84c0.2,0,0.33-0.02,0.44-0.06
                  l0.04,0.5c-0.14,0.06-0.36,0.1-0.64,0.1c-1.04,0-1.07-0.94-1.07-1.4v-2.46h-0.66v-0.51h0.66V228.47z"/>
                        <path class="st3" d="M302.99,232.5c0,0.35,0.01,0.72,0.06,1.02h-0.6l-0.06-0.55h-0.02c-0.22,0.34-0.66,0.64-1.26,0.64
                  c-0.82,0-1.25-0.6-1.25-1.22c0-1.03,0.89-1.58,2.48-1.58c0-0.36,0-1.18-0.97-1.18c-0.37,0-0.75,0.1-1.04,0.31l-0.16-0.45
                  c0.35-0.23,0.82-0.36,1.3-0.36c1.21,0,1.52,0.85,1.52,1.7V232.5z M302.35,231.3c-0.81,0-1.82,0.12-1.82,1.02
                  c0,0.55,0.35,0.79,0.74,0.79c0.64,0,1.08-0.49,1.08-1V231.3z"/>
                        <path class="st3" d="M307.72,229.24c-0.02,0.31-0.04,0.65-0.04,1.18v2.49c0,0.75-0.02,2.46-2.04,2.46c-0.49,0-1.02-0.12-1.34-0.34
                  l0.17-0.51c0.27,0.16,0.69,0.32,1.2,0.32c0.78,0,1.36-0.42,1.36-1.54v-0.51h-0.02c-0.22,0.4-0.67,0.73-1.33,0.73
                  c-1.02,0-1.75-0.9-1.75-2.1c0-1.48,0.93-2.27,1.85-2.27c0.73,0,1.11,0.39,1.29,0.74h0.02l0.03-0.64H307.72z M307.02,230.89
                  c0-0.75-0.54-1.22-1.14-1.22c-0.75,0-1.28,0.67-1.28,1.7c0,0.91,0.44,1.62,1.27,1.62c0.49,0,1.15-0.37,1.15-1.25V230.89z"/>
                        <path class="st3" d="M311.99,233.34c-0.24,0.12-0.69,0.27-1.34,0.27c-1.25,0-1.99-0.88-1.99-2.16c0-1.34,0.75-2.31,1.91-2.31
                  c1.32,0,1.65,1.21,1.65,1.95c0,0.15-0.01,0.26-0.02,0.36h-2.91c0.01,1.18,0.68,1.63,1.45,1.63c0.53,0,0.85-0.11,1.12-0.22
                  L311.99,233.34z M311.58,230.98c0.01-0.58-0.24-1.33-1.07-1.33c-0.78,0-1.13,0.75-1.19,1.33H311.58z"/>
                    </g>
                    <g>
                        <path d="M280.91,228.1h-1.76v5.42h-0.65v-5.42h-1.76v-0.55h4.17V228.1z"/>
                        <path d="M284.17,232.5c0,0.35,0.01,0.72,0.06,1.02h-0.6l-0.06-0.55h-0.02c-0.22,0.34-0.66,0.64-1.26,0.64
                  c-0.82,0-1.25-0.6-1.25-1.22c0-1.03,0.89-1.58,2.48-1.58c0-0.36,0-1.18-0.97-1.18c-0.37,0-0.75,0.1-1.04,0.31l-0.16-0.45
                  c0.35-0.23,0.82-0.36,1.3-0.36c1.21,0,1.52,0.85,1.52,1.7V232.5z M283.53,231.3c-0.81,0-1.82,0.12-1.82,1.02
                  c0,0.55,0.35,0.79,0.74,0.79c0.64,0,1.08-0.49,1.08-1V231.3z"/>
                        <path d="M286.08,233.52h-0.65v-6.27h0.65V233.52z"/>
                        <path d="M290.69,233.52h-0.8l-1.47-2.11l-0.39,0.45v1.66h-0.65v-6.27h0.65v3.99h0.02c0.1-0.15,0.25-0.34,0.37-0.48l1.28-1.51h0.78
                  l-1.61,1.76L290.69,233.52z"/>
                        <path d="M295.78,228.29c-0.17-0.11-0.55-0.27-1.05-0.27c-0.83,0-1.15,0.51-1.15,0.94c0,0.59,0.36,0.89,1.16,1.22
                  c0.96,0.41,1.46,0.9,1.46,1.76c0,0.95-0.69,1.68-1.98,1.68c-0.54,0-1.13-0.17-1.43-0.38l0.18-0.54c0.32,0.21,0.8,0.37,1.29,0.37
                  c0.8,0,1.27-0.43,1.27-1.07c0-0.59-0.32-0.95-1.1-1.26c-0.9-0.34-1.51-0.86-1.51-1.69c0-0.91,0.74-1.58,1.83-1.58
                  c0.56,0,1,0.14,1.22,0.28L295.78,228.29z"/>
                        <path d="M297.4,228.47l0.64-0.22v1h1.11v0.51h-1.11v2.47c0,0.54,0.16,0.84,0.58,0.84c0.2,0,0.33-0.02,0.44-0.06l0.04,0.5
                  c-0.14,0.06-0.36,0.1-0.64,0.1c-1.04,0-1.07-0.94-1.07-1.4v-2.46h-0.66v-0.51h0.66V228.47z"/>
                        <path d="M302.8,232.5c0,0.35,0.01,0.72,0.06,1.02h-0.6l-0.06-0.55h-0.02c-0.22,0.34-0.66,0.64-1.26,0.64
                  c-0.82,0-1.25-0.6-1.25-1.22c0-1.03,0.89-1.58,2.48-1.58c0-0.36,0-1.18-0.97-1.18c-0.37,0-0.75,0.1-1.04,0.31l-0.16-0.45
                  c0.35-0.23,0.82-0.36,1.3-0.36c1.21,0,1.52,0.85,1.52,1.7V232.5z M302.16,231.3c-0.81,0-1.82,0.12-1.82,1.02
                  c0,0.55,0.35,0.79,0.74,0.79c0.64,0,1.08-0.49,1.08-1V231.3z"/>
                        <path d="M307.53,229.24c-0.02,0.31-0.04,0.65-0.04,1.18v2.49c0,0.75-0.02,2.46-2.04,2.46c-0.49,0-1.02-0.12-1.34-0.34l0.17-0.51
                  c0.27,0.16,0.69,0.32,1.2,0.32c0.78,0,1.36-0.42,1.36-1.54v-0.51h-0.02c-0.22,0.4-0.67,0.73-1.33,0.73c-1.02,0-1.75-0.9-1.75-2.1
                  c0-1.48,0.93-2.27,1.85-2.27c0.73,0,1.11,0.39,1.29,0.74h0.02l0.03-0.64H307.53z M306.83,230.89c0-0.75-0.54-1.22-1.14-1.22
                  c-0.75,0-1.28,0.67-1.28,1.7c0,0.91,0.44,1.62,1.27,1.62c0.49,0,1.15-0.37,1.15-1.25V230.89z"/>
                        <path d="M311.8,233.34c-0.24,0.12-0.69,0.27-1.34,0.27c-1.25,0-1.99-0.88-1.99-2.16c0-1.34,0.75-2.31,1.91-2.31
                  c1.32,0,1.65,1.21,1.65,1.95c0,0.15-0.01,0.26-0.02,0.36h-2.91c0.01,1.18,0.68,1.63,1.45,1.63c0.53,0,0.85-0.11,1.12-0.22
                  L311.8,233.34z M311.38,230.98c0.01-0.58-0.24-1.33-1.07-1.33c-0.78,0-1.13,0.75-1.19,1.33H311.38z"/>
                    </g>
                    <g>
                        <g>
                            <path d="M47.02,397.31h-3.15v-5.98h3.02v0.55h-2.37v2.02h2.23v0.54h-2.23v2.31h2.5V397.31z"/>
                            <path d="M51.38,397.31h-0.65v-2.53c0-0.7-0.25-1.31-1-1.31c-0.56,0-1.12,0.47-1.12,1.22v2.62h-0.65v-3.18
                    c0-0.44-0.02-0.76-0.03-1.11h0.58l0.04,0.7h0.02c0.21-0.42,0.71-0.79,1.37-0.79c0.53,0,1.44,0.32,1.44,1.77V397.31z"/>
                            <path d="M52.81,392.26l0.64-0.22v1h1.11v0.51h-1.11v2.47c0,0.54,0.16,0.84,0.58,0.84c0.2,0,0.33-0.02,0.44-0.06l0.04,0.5
                    c-0.14,0.06-0.36,0.1-0.64,0.1c-1.04,0-1.07-0.94-1.07-1.4v-2.46h-0.66v-0.51h0.66V392.26z"/>
                            <path d="M57.36,393.58c-0.07-0.01-0.14-0.02-0.24-0.02c-0.71,0-1.07,0.7-1.07,1.42v2.32h-0.65v-3c0-0.46-0.01-0.87-0.03-1.28
                    h0.57l0.03,0.82h0.02c0.19-0.53,0.64-0.92,1.16-0.92c0.07,0,0.13,0.02,0.2,0.02V393.58z"/>
                            <path d="M60.92,396.29c0,0.35,0.01,0.72,0.06,1.02h-0.6l-0.06-0.55H60.3c-0.22,0.34-0.66,0.64-1.26,0.64
                    c-0.82,0-1.25-0.6-1.25-1.22c0-1.03,0.89-1.58,2.48-1.58c0-0.36,0-1.18-0.97-1.18c-0.37,0-0.75,0.1-1.04,0.31l-0.16-0.45
                    c0.35-0.23,0.82-0.36,1.3-0.36c1.21,0,1.52,0.85,1.52,1.7V396.29z M60.28,395.09c-0.81,0-1.82,0.12-1.82,1.02
                    c0,0.55,0.35,0.79,0.74,0.79c0.64,0,1.08-0.49,1.08-1V395.09z"/>
                            <path d="M65.59,397.31h-0.65v-2.53c0-0.7-0.25-1.31-1-1.31c-0.56,0-1.12,0.47-1.12,1.22v2.62h-0.65v-3.18
                    c0-0.44-0.02-0.76-0.03-1.11h0.58l0.04,0.7h0.02c0.21-0.42,0.71-0.79,1.37-0.79c0.53,0,1.44,0.32,1.44,1.77V397.31z"/>
                            <path d="M69.74,397.15c-0.19,0.09-0.61,0.24-1.16,0.24c-1.22,0-2.03-0.87-2.03-2.18c0-1.32,0.87-2.28,2.19-2.28
                    c0.48,0,0.86,0.14,1.03,0.23l-0.16,0.53c-0.18-0.1-0.46-0.22-0.88-0.22c-0.99,0-1.51,0.79-1.51,1.71c0,1.04,0.62,1.69,1.48,1.69
                    c0.42,0,0.71-0.12,0.93-0.21L69.74,397.15z"/>
                            <path d="M73.68,397.13c-0.24,0.12-0.69,0.27-1.34,0.27c-1.25,0-1.99-0.88-1.99-2.16c0-1.34,0.75-2.31,1.91-2.31
                    c1.32,0,1.65,1.21,1.65,1.95c0,0.15-0.01,0.26-0.02,0.36h-2.91c0.01,1.18,0.68,1.63,1.45,1.63c0.53,0,0.85-0.11,1.12-0.22
                    L73.68,397.13z M73.26,394.76c0.01-0.58-0.24-1.33-1.07-1.33c-0.78,0-1.13,0.75-1.19,1.33H73.26z"/>
                        </g>
                    </g>
                    <rect x="132.39" y="361.96" width="60.67" height="17.2"/>
                    <g>
                        <g>
                            <path class="st2" d="M143.4,370.5l0.05,0.82c-0.14,0.06-0.26,0.12-0.64,0.24v2.27c0,0.51-0.21,0.64-0.6,0.64h-0.84l-0.1-0.82h0.6
                    c0.13,0,0.19-0.06,0.19-0.18v-1.67c-0.5,0.14-0.56,0.17-0.75,0.2l-0.1-0.82c0.22-0.05,0.42-0.09,0.85-0.22v-1.76h-0.82v-0.76
                    h0.82v-1.37h0.76v1.37h0.58v0.76h-0.58v1.51C143.08,370.65,143.22,370.58,143.4,370.5h-0.05v-0.66h5.27v0.66h-2.75v3.98h-0.68
                    v-0.53c-0.69,0.13-1.21,0.2-1.83,0.26l-0.11-0.64c0.15-0.02,0.24-0.02,0.41-0.04v-3.03H143.4z M148.1,367.3v2.19h-4.24v-2.19
                    H148.1z M144.32,370.5v0.54h0.85v-0.54H144.32z M144.32,371.6v0.54h0.85v-0.54H144.32z M145.18,372.72h-0.85v0.71
                    c0.18-0.02,0.42-0.06,0.85-0.14V372.72z M144.59,367.85v0.37h2.78v-0.37H144.59z M144.59,368.62V369h2.78v-0.38H144.59z
                    M146.68,371.76c0.09,0.21,0.19,0.47,0.51,0.85c0.31-0.48,0.4-0.82,0.46-1.05h-1.51v-0.65h2.2v0.65
                    c-0.07,0.3-0.21,0.89-0.64,1.55c0.45,0.37,0.79,0.53,1.04,0.65l-0.41,0.71c-0.3-0.17-0.62-0.35-1.1-0.76
                    c-0.34,0.37-0.61,0.56-0.84,0.72l-0.42-0.61c0.2-0.13,0.44-0.28,0.76-0.62c-0.45-0.53-0.56-0.86-0.67-1.15L146.68,371.76z"/>
                            <path class="st2" d="M152.25,372.94c-0.23,0.58-0.69,1.1-0.95,1.36l-0.53-0.47c0.23-0.2,0.62-0.61,0.88-1.21L152.25,372.94z
                    M151.21,367.36h3.78v2.24h-1.53v0.33h1.88v0.6h-4.49v-0.6h1.89v-0.33h-1.54V367.36z M152.75,372.5h-1.59v-1.65h3.91v1.65h-1.61
                    v1.47c0,0.16-0.08,0.47-0.49,0.47h-0.93l-0.14-0.78h0.69c0.09,0,0.16,0,0.16-0.11V372.5z M151.84,371.42v0.55h2.55v-0.55H151.84z
                    M151.9,367.94v0.34h2.41v-0.34H151.9z M151.9,368.72v0.36h2.41v-0.36H151.9z M154.87,373.85l-0.26,0.15
                    c-0.34-0.55-0.56-0.84-0.81-1.11l0.59-0.35c0.42,0.42,0.69,0.87,0.78,1.04c0.65-0.29,1.62-0.86,2.47-2.1l0.57,0.6
                    c-0.85,1.19-1.7,1.8-2.91,2.36L154.87,373.85z M155.15,371.13c0.34-0.16,1.58-0.81,2.35-2.01l0.62,0.51
                    c-0.3,0.51-1.21,1.53-2.49,2.2L155.15,371.13z M155.27,368.81c0.57-0.31,1.4-0.82,2.03-1.74l0.7,0.45
                    c-0.27,0.43-1.13,1.36-2.23,1.97L155.27,368.81z"/>
                            <path class="st2" d="M165.32,367c0.14,0.33,0.22,0.6,0.33,1.09l-0.23,0.05h0.46c-0.13,3.53-1.98,5.38-4.79,5.98l-0.49-0.84
                    c1.26-0.24,3.86-0.76,4.28-4.29h-4.96v-0.85h5.03c-0.09-0.45-0.18-0.72-0.3-1.03L165.32,367z M166.15,368.19
                    c-0.06-0.31-0.2-0.84-0.34-1.14l0.64-0.12c0.15,0.38,0.22,0.62,0.32,1.11L166.15,368.19z"/>
                            <path class="st2" d="M175.92,370.26v0.95h-6.96v-0.95H175.92z"/>
                            <path class="st2" d="M178.34,373.36c1.68-0.61,3.65-2.32,4.53-4.71h-4.08v-0.85h5.27c-0.11,0.47-0.38,1.71-1.51,3.25
                    c0.92,0.74,1.81,1.51,2.65,2.33l-0.74,0.75c-0.89-1.04-2.09-2.1-2.45-2.4c-0.91,1.05-1.9,1.87-3.14,2.37L178.34,373.36z"/>
                        </g>
                    </g>
                    <g>
                        <g>
                            <path d="M146.2,381.74c0.35-0.06,0.8-0.12,1.36-0.12c1.93,0,2.09,1.24,2.09,1.71c0,1.4-1.12,1.91-2.18,1.91
                    c-0.23,0-0.43-0.01-0.61-0.06v2.46h-0.65V381.74z M146.85,384.64c0.16,0.05,0.38,0.06,0.63,0.06c0.94,0,1.51-0.47,1.51-1.33
                    s-0.61-1.23-1.43-1.23c-0.33,0-0.57,0.03-0.71,0.06V384.64z"/>
                            <path d="M153.9,387.63h-0.65v-2.53c0-0.7-0.25-1.3-0.99-1.3c-0.5,0-1.13,0.42-1.13,1.2v2.63h-0.65v-6.27h0.65v2.66h0.02
                    c0.28-0.47,0.8-0.76,1.33-0.76s1.43,0.32,1.43,1.77V387.63z"/>
                            <path d="M158.64,385.46c0,1.59-1.05,2.27-2,2.27c-1.1,0-1.94-0.82-1.94-2.2c0-1.46,0.91-2.27,2-2.27
                    C157.86,383.26,158.64,384.15,158.64,385.46z M156.67,383.77c-0.93,0-1.31,0.91-1.31,1.73c0,0.95,0.53,1.72,1.29,1.72
                    c0.78,0,1.32-0.77,1.32-1.73C157.97,384.73,157.6,383.77,156.67,383.77z"/>
                            <path d="M159.79,382.58l0.64-0.22v1h1.11v0.51h-1.11v2.47c0,0.54,0.16,0.84,0.58,0.84c0.2,0,0.33-0.02,0.44-0.06l0.04,0.5
                    c-0.14,0.06-0.36,0.1-0.64,0.1c-1.04,0-1.07-0.94-1.07-1.4v-2.46h-0.66v-0.51h0.66V382.58z"/>
                            <path d="M165.87,385.46c0,1.59-1.05,2.27-2,2.27c-1.1,0-1.94-0.82-1.94-2.2c0-1.46,0.91-2.27,2-2.27
                    C165.1,383.26,165.87,384.15,165.87,385.46z M163.9,383.77c-0.93,0-1.31,0.91-1.31,1.73c0,0.95,0.53,1.72,1.29,1.72
                    c0.78,0,1.32-0.77,1.32-1.73C165.21,384.73,164.84,383.77,163.9,383.77z"/>
                            <path d="M170.28,382.4c-0.17-0.11-0.55-0.27-1.05-0.27c-0.83,0-1.15,0.51-1.15,0.94c0,0.59,0.36,0.89,1.16,1.22
                    c0.96,0.41,1.46,0.9,1.46,1.76c0,0.95-0.69,1.68-1.98,1.68c-0.54,0-1.13-0.17-1.43-0.38l0.18-0.54c0.32,0.21,0.8,0.37,1.29,0.37
                    c0.8,0,1.27-0.43,1.27-1.07c0-0.59-0.32-0.95-1.1-1.26c-0.9-0.34-1.51-0.86-1.51-1.69c0-0.91,0.74-1.58,1.83-1.58
                    c0.56,0,1,0.14,1.22,0.28L170.28,382.4z"/>
                            <path d="M172.02,384.08c0.3-0.53,0.79-0.82,1.46-0.82c1.01,0,1.74,0.87,1.74,2.18c0,1.57-0.92,2.29-1.86,2.29
                    c-0.56,0-1.04-0.26-1.29-0.68h-0.02v2.34h-0.65v-4.65c0-0.56-0.02-0.99-0.03-1.38h0.59l0.04,0.73H172.02z M172.05,385.93
                    c0,0.83,0.62,1.27,1.2,1.27c0.84,0,1.3-0.72,1.3-1.74c0-0.89-0.45-1.67-1.28-1.67c-0.73,0-1.22,0.71-1.22,1.33V385.93z"/>
                            <path d="M179.82,385.46c0,1.59-1.05,2.27-2,2.27c-1.1,0-1.94-0.82-1.94-2.2c0-1.46,0.91-2.27,2-2.27
                    C179.05,383.26,179.82,384.15,179.82,385.46z M177.86,383.77c-0.93,0-1.31,0.91-1.31,1.73c0,0.95,0.53,1.72,1.29,1.72
                    c0.78,0,1.32-0.77,1.32-1.73C179.16,384.73,178.79,383.77,177.86,383.77z"/>
                            <path d="M180.98,382.58l0.64-0.22v1h1.11v0.51h-1.11v2.47c0,0.54,0.16,0.84,0.58,0.84c0.2,0,0.33-0.02,0.44-0.06l0.04,0.5
                    c-0.14,0.06-0.36,0.1-0.64,0.1c-1.04,0-1.07-0.94-1.07-1.4v-2.46h-0.66v-0.51h0.66V382.58z"/>
                        </g>
                    </g>
                </g>
                <g id="area21" @click="onClick('東京カメラ部10選10世代合同展示')">
                    <rect x="754.34" y="52.44" class="st4 area21" :class="{ 'selected': isSelected['10sen'] }" width="24.06" height="324.84"/>
                    <rect x="705.26" y="52.44" class="st4 area21" :class="{ 'selected': isSelected['10sen'] }" width="24.06" height="324.84"/>
                    <polygon class="st4 area21" points="658.1,362.41 682.16,362.41 682.16,65.3 670.13,65.3 670.13,129.4 658.1,129.4"/>
                </g>
                <g id="area20" @click="onClick('日本写真100景＜四季＞2022 フォトコンテスト')">
                    <rect x="609.01" y="65.3" class="st4 area20" :class="{ 'selected': isSelected['100kei'] }" width="24.06" height="297.11"/>
                    <rect x="658.1" y="65.3" class="st4 area20" :class="{ 'selected': isSelected['100kei'] }" width="12.03" height="64.1"/>
                </g>
                <g id="area19" @click="onClick('横須賀市（横須賀集客促進・魅力発信実行委員会）')">
                    <rect x="551.96" y="337.82" class="st4 area19" width="30.07" height="30.07"/>
                </g>
                <g id="area18" @click="onClick('東川町・ひがしかわ観光協会')">
                    <rect x="551.96" y="268.41" class="st4 area18" width="30.07" height="30.07"/>
                </g>
                <g id="area17" @click="onClick('美瑛町（ＮＰＯ法人 美瑛町写真映像協会）')">
                    <rect x="551.96" y="199" class="st4 area17" width="30.07" height="30.07"/>
                </g>
                <g id="area16" @click="onClick('浜松市')">
                    <rect x="551.96" y="129.59" class="st4 area16" width="30.07" height="30.07"/>
                </g>
                <g id="area15" @click="onClick('岐阜市')">
                    <rect x="551.96" y="60.18" class="st4 area15" width="30.07" height="30.07"/>
                </g>
                <g id="area14" @click="onClick('小森コーポレーション')">
                    <rect x="474.45" y="320.55" class="st4 area14" width="44.87" height="45.92"/>
                </g>
                <g id="area13" @click="onClick('大本山大聖院')">
                    <rect x="474.45" y="250.26" class="st4 area13" width="44.87" height="45.92"/>
                </g>
                <g id="area12" @click="onClick('パナソニック エンターテインメント＆コミュニケーション、ライカカメラジャパン')">
                    <rect x="474.45" y="178.35" class="st4 area12" width="44.87" height="45.92"/>
                </g>
                <g id="area11" @click="onClick('富士フイルムイメージングシステムズ')">
                    <rect x="474.45" y="61.77" class="st4 area11" width="44.87" height="90.22"/>
                </g>
                <g id="area10" @click="onClick('2022写真コンテスト Instagram部門（３×３）')">
                    <rect x="401.04" y="385.71" class="st4 area10" :class="{ 'selected': isSelected['insta'] }" width="107.88" height="18.69"/>
                    <rect x="253.68" y="385.71" class="st4 area10" :class="{ 'selected': isSelected['insta'] }" width="107.88" height="18.69"/>
                </g>
                <g id="area9" @click="onClick('サードウェーブ')">
                    <rect x="396.48" y="320.55" class="st4 area9" width="44.87" height="45.92"/>
                </g>
                <g id="area8" @click="onClick('Ｔ＆Ｄ保険グループ')">
                    <rect x="396.76" y="190.92" class="st4 area8" :class="{ 'selected': isSelected['sponsors'] }" width="44.87" height="90.22"/>
                </g>
                <g id="area7" @click="onClick('日本航空、東海旅客鉄道、東京地下鉄、東日本旅客鉄道、全日本空輸')">
                    <rect x="320.63" y="26.28" class="st4 area7" width="30.15" height="16.12"/>
                </g>
                <g id="area6" @click="onClick('キヤノンマーケティングジャパン')">
                    <rect x="396.76" y="61.77" class="st4 area6" :class="{ 'selected': isSelected['sponsors'] }" width="44.87" height="90.22"/>
                    <rect x="51.08" y="27.44" class="st4 area6" :class="{ 'selected': isSelected['sponsors'] }" width="37.94" height="98.13"/>
                </g>
                <g id="area5" @click="onClick('日本写真100景「城と月」特別部門 フォトコンテスト')">
                    <rect x="187.12" y="110.71" class="st4 area5" :class="{ 'selected': isSelected['shiro'] }" width="19.47" height="81.19"/>
                </g>
                <g id="area4" @click="onClick('「ご当地グルメ」 on Twitter フォトコンテスト')">
                    <rect x="187.12" y="213.02" class="st4 area4" :class="{ 'selected': isSelected['twitter'] }" width="19.47" height="81.19"/>
                </g>
                <g id="area3" @click="onClick('Japan Travel Gallery Photo Contest 2022 / Weibo')">
                    <rect x="119.38" y="220.4" class="st4 area3" :class="{ 'selected': isSelected['jtg_weibo'] }" width="16.36" height="81.19"/>
                </g>
                <g id="area2" @click="onClick('ソニー・ミュージックエンタテインメント')">
                    <rect x="103.01" y="220.4" class="st4 area2" :class="{ 'selected': isSelected['sponsors'] }" width="16.36" height="81.19"/>
                </g>
                <g id="area1" @click="onClick('本田技研工業')">
                    <rect x="54.89" y="168.4" class="st4 area1" width="17.21" height="45.29"/>
                </g>
            </svg>
            <div class="textComment">
              {{textComment}}
            </div>
          </div>
        </section><!-- /photobook-->
      </div><!-- /main-->
    </div>
    <Footer />
    <div class="actionMenu">
      <UpButton />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'
import WinnerLinkUtil from '@/util/WinnerLinkUtil'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    UpButton
  },
  data () {
    return {
      query: '',
      searchedAwardTypes: [],
      searchedWinnersByAwardType: {},
      textComment: '',
      isSelected: []
    }
  },
  computed: {
    ...mapGetters([
      'winners',
      'winnersByAwardType'
    ]),
  },
  methods: {
    isDemo () {
      return process.env.VUE_APP_DEMO_HOST ? (location.host.indexOf(process.env.VUE_APP_DEMO_HOST) >= 0) : false
    },
    onClick (name) {
      this.textComment = name
    },
    setTitleAndDescription (to) {
      document.title = (to.meta.title ? to.meta.title : '')
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : ''))
    },
    getWinnerLink (winner) {
      return WinnerLinkUtil.getUrl(winner)
    },
    onInput () {
      this.searchWinner(this.query)
    },
    searchWinner (query) {
      this.textComment = ''
      this.isSelected = []
      this.searchedAwardTypes = []
      this.searchedWinnersByAwardType = {}
      // まずwinnersを検索する
      for (const winner of this.winners) {
        const name = winner.name ? winner.name.toLowerCase() : ''
        const nameOption1 = winner.nameOption1 ? winner.nameOption1.toLowerCase() : ''
        const nameOption2 = winner.nameOption2 ? winner.nameOption2.toLowerCase() : ''
        const searchQuery = query.toLowerCase()
        if (name.indexOf(searchQuery) >= 0 || nameOption1.indexOf(searchQuery) >= 0 || nameOption2.indexOf(searchQuery) >= 0) {
          if (!this.searchedAwardTypes.includes(winner.awardType) && this.awardTypes.includes(winner.awardType)) {
            this.searchedAwardTypes.push(winner.awardType)
          }
          if (!this.searchedWinnersByAwardType[winner.awardType]) {
            this.searchedWinnersByAwardType[winner.awardType] = []
          }
          for (const tempWinner of this.winnersByAwardType(winner.awardType)) {
            if (tempWinner.id == winner.id) {
              this.searchedWinnersByAwardType[winner.awardType].push(tempWinner)
            }
          }
        }
      }
      if (query) {
        if (this.searchedAwardTypes.includes(1) || this.searchedAwardTypes.includes(2) || this.searchedAwardTypes.includes(3) || this.searchedAwardTypes.includes(4) || this.searchedAwardTypes.includes(5) || this.searchedAwardTypes.includes(6) || this.searchedAwardTypes.includes(7) || this.searchedAwardTypes.includes(8) || this.searchedAwardTypes.includes(9) || this.searchedAwardTypes.includes(10)) this.isSelected['10sen'] = true
        if (this.searchedAwardTypes.includes(11)) this.isSelected['100kei'] = true
        if (this.searchedAwardTypes.includes(12)) this.isSelected['shiro'] = true
        if (this.searchedAwardTypes.includes(13)) this.isSelected['jtg_weibo'] = true
        if (this.searchedAwardTypes.includes(14)) this.isSelected['jtg_weibo'] = true
        if (this.searchedAwardTypes.includes(15)) this.isSelected['twitter'] = true
        if (this.searchedAwardTypes.includes(16)) this.isSelected['sponsors'] = true
        if (this.searchedAwardTypes.includes(17)) this.isSelected['insta'] = true
      }
    }
  },
  created () {
    this.isSelectedArea1 = true;
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)

    this.searchedAwardTypes = this.awardTypes
    setTimeout(() => {
      const tempWinnersByAwardType = {}
      for (const awardType of this.searchedAwardTypes) {
        tempWinnersByAwardType[awardType] = this.winnersByAwardType(awardType)
      }
      this.searchedWinnersByAwardType = tempWinnersByAwardType
    }, 500)
  },
  watch: {
    $route: function (to) {
      this.setTitleAndDescription(to)
    },

  }
}
</script>

<style scoped>
.st0{fill:#949494;}
.st1{fill:#CCCCCC;}
.st2{fill:#FFFFFF;}
.st3{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
.st4{fill:#B0CCDB;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}

.area1{fill:#B0CCDB;cursor: pointer;}  /* 本田技研工業 */
.area2{fill:#B0CCDB;cursor: pointer;}  /* ソニー・ミュージックエンタテインメント */
.area3{fill:#B0CCDB;cursor: pointer;}  /* Japan Travel Gallery Photo Contest 2022 ／ Weibo */
.area4{fill:#B0CCDB;cursor: pointer;}  /* 「ご当地グルメ」 on Twitter フォトコンテスト */
.area5{fill:#B0CCDB;cursor: pointer;}  /* 日本写真100景「城と月」特別部門 フォトコンテスト */
.area6{fill:#B0CCDB;cursor: pointer;}  /* キヤノンマーケティングジャパン */
.area7{fill:#B0CCDB;cursor: pointer;}  /* 日本航空、東海旅客鉄道、東京地下鉄、東日本旅客鉄道、全日本空輸 */
.area8{fill:#B0CCDB;cursor: pointer;}  /* Ｔ＆Ｄ保険グループ */
.area9{fill:#B0CCDB;cursor: pointer;}  /* サードウェーブ */
.area10{fill:#B0CCDB;cursor: pointer;} /* 2022写真コンテスト Instagram部門（３×３） */
.area11{fill:#B0CCDB;cursor: pointer;} /* 富士フイルムイメージングシステムズ */
.area12{fill:#B0CCDB;cursor: pointer;} /* パナソニック エンターテインメント＆コミュニケーション、ライカカメラジャパン */
.area13{fill:#B0CCDB;cursor: pointer;} /* 大本山大聖院 */
.area14{fill:#B0CCDB;cursor: pointer;} /* 小森コーポレーション */
.area15{fill:#B0CCDB;cursor: pointer;} /* 岐阜市 */
.area16{fill:#B0CCDB;cursor: pointer;} /* 浜松市 */
.area17{fill:#B0CCDB;cursor: pointer;} /* 美瑛町（ＮＰＯ法人 美瑛町写真映像協会） */
.area18{fill:#B0CCDB;cursor: pointer;} /* 東川町・ひがしかわ観光協会 */
.area19{fill:#B0CCDB;cursor: pointer;} /* 横須賀市（横須賀集客促進・魅力発信実行委員会） */
.area20{fill:#B0CCDB;cursor: pointer;} /* 日本写真100景＜四季＞2022 フォトコンテスト */
.area21{fill:#B0CCDB;cursor: pointer;} /* 東京カメラ部10選10世代合同展示 */

.selected{fill:#ee0000}

.mapArea {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0px 0px 160px 0px;
}

.mapArea .mapTitle {
  margin: 24px 0px 32px 0px;
  max-width: 960px;
  text-align: center;
  font-size: 1.6rem;
  font-family: fot-matisse-pron,sans-serif;
}

.mapArea svg {
  max-width: 960px;
}

.mapArea .textComment {
  margin-top: 24px;
  height: 32px;
  max-width: 960px;
  text-align: center;
  font-size: 1rem;
  font-family: fot-matisse-pron,sans-serif;
}

.commingSoon {
  height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.commingSoonMessage {
  margin-top: -24px;
  text-align: center;
  font-size: 3rem;
  width: 600px;
}

.searchErrorMessage {
  width: 100%;
  font-size: 1rem;
  text-align: center;
}
</style>
